// extracted by mini-css-extract-plugin
module.exports = {"displaygrid":"about-partner-module--displaygrid--3Egxm","partnerbox":"about-partner-module--partnerbox--KUaiV"};